import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { ToastrService } from 'ngx-toastr';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';

import { ConfirmComponent } from '../../modals';
import { TaskNotesComponent } from '../../modals';
import { MeetingsService } from '../../services';
import { TasksService } from '../../services';

export interface NotificationRecipientsModel {
	title:string;
	button:string;
    label:string;
    recipients:Array<any>;
    edit: boolean;

    notification_ended:boolean;

    survey: boolean;
    survey_status: number;
}

@Component({  
    selector: 'notification-recipients',
    templateUrl: './notification-recipients.html',
    styleUrls: ['./notification-recipients.scss']
})

export class NotificationRecipientsComponent extends DialogComponent<NotificationRecipientsModel, any> implements NotificationRecipientsModel, OnInit {
  	title:string;
    button:string;
  	label:string;
    recipients:Array<any>;
    edit: boolean;

    notification_ended:boolean;

    survey: boolean;
    survey_status: number;

    data = [];
    filterQuery = '';
    rowsOnPage = 10;
    sortBy = 'name';
    sortOrder = 'asc';

    private searchForm: FormGroup;
    private search:AbstractControl;
    private recipients_control:AbstractControl;

    private filter_term:string;
    
    private recipients_arr = [];
    private dropdownSettings: IMultiSelectSettings = {
        enableSearch: false,
        checkedStyle: 'fontawesome',
        buttonClasses: 'btn btn-default btn-block',
        dynamicTitleMaxItems: 10,
        fixedTitle: true,
        closeOnClickOutside: false,
        selectionLimit: 1,
        autoUnselect: true,
        containerClasses: 'dropdown-members'
    };

    private users_text: IMultiSelectTexts = {
        searchPlaceholder: 'Pronađi člana',
        searchEmptyResult: 'Nije pronađen niti jedan član...',
        defaultTitle: 'Dodaj člana...',
    };

    private search_error_msg:boolean = false;
    private errorMsg:string = '';

  	constructor(
        dialogService: DialogService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private slimLoader: SlimLoadingBarService,
        private meetingsService: MeetingsService
    ) {
    	super(dialogService);
  	}

    // For datatables
    toInt(num: string) {
        return +num;
    }

    ngOnInit() {

        this.searchForm = this.formBuilder.group({
            search: [''],
            recipients_control: []
        });

        this.search = this.searchForm.controls['search'];

        this.searchForm.controls['recipients_control'].valueChanges.subscribe((value) => {
            if(value !== null){
                if(value.length > 0){
                    for(let i = 0; i < value.length; i++){
                        this.addUser(value[i]);
                    }
                }
            }
        });

        if(this.recipients.length > 0){
            for( let i = 0; i < this.recipients.length; i++){
                if(this.recipients[i].recipient_id){
                    this.recipients[i].id = this.recipients[i].recipient_id;
                } else if(this.recipients[i].member_id){
                     this.recipients[i].id = this.recipients[i].member_id;
                }
                this.data.push(this.recipients[i]);
            }
        }
    }

    // Add user function
    addUser(value) {
        this.searchForm.controls.recipients_control.reset();
        let found = this.data.some(function (el) {
            return el.id === value;
        });
        if (!found) {
            for( let i = 0; i < this.recipients_arr.length; i++){
                if(this.recipients_arr[i].id === value){
                    let activeModal = this.dialogService.addDialog(ConfirmComponent, {
                        title:'Dodaj člana', 
                        message:'Jeste li sigurni da želite dodati ' + this.recipients_arr[i].first_name + ' ' + this.recipients_arr[i].last_name + ' ?',
                        button: 'Dodaj',
                    })
                    .subscribe((isConfirmed)=>{
                        if(isConfirmed) {
                            //Add user to datatable
                            this.data.push(this.recipients_arr[i]);
                            this.toastr.success("Uspješno ste dodali člana");
                        }
                    });
                }
            }
        } else {
            this.toastr.error("Korisnik je već dodan kao član!");
        }
    }

    //Search users function
    searchUsers(term){
        this.filter_term = term;
        
        this.meetingsService.getMeetingMembers(this.filter_term).subscribe(
            response => {
                if(response.users.length > 0){
                    this.search_error_msg = false;
                    for(let i = 0; i < response.users.length; i++){
                        if(response.users[i].first_name){
                            response.users[i].name = response.users[i].first_name + ' ' + response.users[i].last_name + ' - ' + response.users[i].email;
                        } else {
                            response.users[i].name = response.users[i].email;
                        }
                    }
                } else {
                    this.search_error_msg = true;
                }
                this.recipients_arr = response.users;
                this.slimLoader.complete();
            },
            error => {
                if(error.error_msg){
                    this.toastr.error(error.error_msg);
                    this.errorMsg = error.error_msg;
                    this.slimLoader.complete();
                }
            },
        );
    }

    //Delete user from datatable
    onDeleteUser(user){
        let activeModal = this.dialogService.addDialog(ConfirmComponent, {
            title:'Izbriši člana', 
            message:'Jeste li sigurni da želite izbrisati ' + user.first_name + ' ' + user.last_name + ' ?',
            button: 'Izbriši',
        })
        .subscribe((isConfirmed)=>{
            if(isConfirmed) {
                if(user.id){
                    let id = user.id;
                    const toDelete = new Set([id]);

                    //Remove user from datatable
                    this.data = this.data.filter(obj => !toDelete.has(obj.id));
                    this.toastr.success("Uspješno ste izbrisali člana");
                    this.searchForm.controls.recipients_control.reset();
                } else if(user.recipient_id){
                    let id = user.recipient_id;
                    const toDelete = new Set([id]);

                    //Remove user from datatable
                    this.data = this.data.filter(obj => !toDelete.has(obj.recipient_id));
                    this.toastr.success("Uspješno ste izbrisali člana");
                    this.searchForm.controls.recipients_control.reset();
                } else {
                    let id = user.member_id;
                    const toDelete = new Set([id]);

                    //Remove user from datatable
                    this.data = this.data.filter(obj => !toDelete.has(obj.member_id));
                    this.toastr.success("Uspješno ste izbrisali člana");
                    this.searchForm.controls.recipients_control.reset();
                }
            }
        });
    }

  	confirm(data) {
    	// we set dialog result as true on click on confirm button, 
    	// then we can get dialog result from caller code
    	this.result = data;
    	this.close();
  	}
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/notification-recipients/notification-recipients.component.ts